import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {IonModal, ModalController, ModalOptions} from "@ionic/angular";

@Component({
  selector: 'app-drawer-modal',
  templateUrl: './drawer-modal.component.html',
  styleUrls: ['./drawer-modal.component.scss'],
})
export class DrawerModalComponent  implements OnInit, AfterViewInit {

  @ViewChild('modal', { static: true }) modal: IonModal;
  @ViewChild('footerTmp') footerTmp!: ElementRef;

  @Input() title: string;
  @Input() subTitle: string;

  @Input() imageHeader: string;
  @Input() imageHeaderClass: string;

  @Input() option: ModalOptions = {
    breakpoints: [0,1],
    initialBreakpoint: 1,
    component: DrawerModalComponent
  };

  @Output() getModalRef: EventEmitter<IonModal> = new EventEmitter();

  contentPaddingBottom: number;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.getModalRef.emit(this.modal);
  }

  onTest(){
    this.contentPaddingBottom = this.footerTmp.nativeElement.offsetHeight;
  }

  open() {
    this.modal.present();
  }

  close(){
    this.modalCtrl.dismiss();
  }

}
